import React from 'react'
import { Result, Spin, Table, Typography  } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import Chart from "react-apexcharts"

const { Title } = Typography


const ModelStatistics = ({ rsSkillsGroup, modelStatistics }) => {

  function dataStatus() {
    if (

      modelStatistics === null &&
      rsSkillsGroup === null
    ) {
      return "loading"
    } else if (
      typeof modelStatistics === 'object' && modelStatistics !== null &&
      Array.isArray(rsSkillsGroup)
    ) {
      return "ok"
    } else {
      return "error"
    }
  }

  const colors = ['#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800']

  const topSkillsColumns = [
    {
      title: 'Skill Group',
      dataIndex: 'skillId',
      key: 'skillId',
      render: value => rsSkillsGroup.find(e => e.id === value).name
    },
    {
      title: 'Occurrence',
      dataIndex: 'percentage',
      key: 'percentage',
      width: "90px",
      align: "right",
      render: value => <>{value} %</>
    }
  ]

  return (
    <section className="statistics">
      <span><Title className="pageTitle">Model Statistics</Title></span>
      <div className={modelStatistics ? " " : " vertCenter"}>
        {
          dataStatus() === "loading" ? (
            <Spin tip="Loading..." indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
          ) : dataStatus() === "error" ? (
            <Result
              status="500"
              title="500"
              subTitle="Sorry, something went wrong."
            />
          ) : (
            <>
              <Table 
                size="small" 
                pagination={false} 
                columns={topSkillsColumns} 
                dataSource={modelStatistics.top_skills} 
                className="topSkillsTable" 
                title={() => 'List of the 10 most sought-after skills (for medium dataset)'} 
                rowKey="rank"
              />

              <div className="chart-container">
                <Chart
                  type="radar"
                  series={[{
                    name: "Skill occurence",
                    data: modelStatistics.radar_plot ? modelStatistics.radar_plot.map(e => e.occurrence) : []
                  }]}
                  options= {{
                    colors: [colors[0]],
                    chart: {
                      toolbar: {
                        show: false
                      },
                    },
                    xaxis: {
                      categories: modelStatistics.radar_plot ? modelStatistics.radar_plot.map(i => rsSkillsGroup.find(e => e.id === i.skillId).name) : []
                    },
                  }}
                />
              </div>
            </>
          )
        }
      </div>
    </section>
  )
}

export default ModelStatistics
